import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CommonAuthService } from 'common/auth/common-auth.service';

@Injectable({
  providedIn: 'root'
})
export class SSOStateResolverService {
  constructor(private commonAuthService: CommonAuthService) {
  }

  async resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    return this.commonAuthService.init(true, activatedRouteSnapshot);
  }
}
